import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_BASE_URL from '../config';

// Async thunk for generating test data
export const generateTestData = createAsyncThunk(
  'generate/generateTestData',
  async (requestData, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      
      const response = await axios.post(
        `${API_BASE_URL}/api/generate-test-data`,
        requestData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      const ct = String(response.headers['content-type'] || '');
      if (ct.includes('text/csv') || typeof response.data === 'string') {
        const rid = response.headers['x-request-id'];
        return {
          success: true,
          data: [],
          requestId: rid ? parseInt(String(rid), 10) : null,
          format: 'csv',
          rawCsv: String(response.data || ''),
        };
      }

      if (response.data && response.data.success) {
        return response.data;
      }

      return rejectWithValue(response.data?.message || 'Failed to generate test data');
    } catch (error) {
      const errorMsg = error.response?.data?.message || error.response?.data?.error || 'Failed to generate test data';
      return rejectWithValue(errorMsg);
    }
  }
);

const initialState = {
  // Test data generation result
  testData: null,
  
  // UI states
  loading: false,
  error: null,
  success: false,
  
  // Generation metadata
  generatedAt: null,
  requestId: null,
};

const generateSlice = createSlice({
  name: 'generate',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    clearTestData: (state) => {
      state.testData = null;
      state.generatedAt = null;
      state.requestId = null;
      state.success = false;
      state.error = null;
    },
    resetGenerateState: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      // Generate test data
      .addCase(generateTestData.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(generateTestData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.testData = action.payload.data || action.payload.testData || action.payload;
        state.generatedAt = new Date().toISOString();
        state.requestId = action.payload.requestId || null;
        state.error = null;
      })
      .addCase(generateTestData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to generate test data';
        state.success = false;
        state.testData = null;
      });
  },
});

export const { 
  clearError, 
  clearSuccess, 
  clearTestData,
  resetGenerateState 
} = generateSlice.actions;

export default generateSlice.reducer;
